import {AppRoute} from "./types/AppRoute";
import awsconfig from "./configs/awsconfig.json";

const routes: AppRoute[] = [
  {
    path: "/upload",
    name: "Upload",
    icon: "fa fa-upload",
    protected: true
  },
  {
    path: "/files",
    name: "My Logs",
    icon: "fa fa-file",
    protected: true
  },
  // {
  //   path: "/live",
  //   name: "ANT+ Log Live",
  //   icon: "fa fa-signal",
  //   protected: true
  // },
  {
    path: `/report/${awsconfig.Environment.demo}`,
    name: "Demo",
    icon: "fa fa-chart-bar",
    protected: false
  },
  {
    path: "/benchmarks",
    name: "Benchmarks",
    icon: "fa fa-align-left",
    protected: false
  },
  {
    path: "/gpu-profiles",
    name: "GPU Profiles",
    icon: "fa fa-microchip",
    protected: false
  },
  {
    path: "/ping",
    name: "Ping Test",
    icon: "fa fa-cloud-download-alt",
    protected: false
  },
  {
    path: "/search",
    name: "Search",
    icon: "fa fa-search",
    protected: false
  },
  {
    path: "/contact",
    name: "Contact",
    icon: "fa fa-envelope",
    protected: false
  },
  {
    path: "/about",
    name: "About Us",
    icon: "fa fa-info-circle",
    protected: false
  },
  {
    name: "Help",
    icon: "fa fa-question",
    protected: false,
    onClick: () => {
      // This will be overridden in the Sidebar component to use the actual openHelp function
    }
  }
];
export default routes;
